
// import { useState, useRef, useEffect } from "react";
// import { FaAngleDown } from "react-icons/fa";

// const CustomDropdown = ({ label, value, onChange, options, placeholder, disabled }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const ref = useRef();

//   useEffect(() => {
//     const handleClickOutside = e => {
//       if (ref.current && !ref.current.contains(e.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const selectedOption = options?.find(opt => opt?.value === value);

//   const handleToggle = () => {
//     if (!disabled) {
//       setIsOpen(!isOpen);
//     }
//   };

//   const handleSelect = val => {
//     if (!disabled) {
//       onChange(val);
//       setIsOpen(false);
//     }
//   };

//   return (
//     <div
//       ref={ref}
//       className={`relative ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
//     >
//       <label className="block text-lg font-semibold !text-themeBlue mb-3" style={{color:"#00519D !important"}}>
//         {label}
//       </label>

//       <div
//         className={`w-full px-4 py-3 bg-white border border-themeCardBorder rounded-md shadow-sm flex justify-between items-center ${
//           disabled ? "cursor-not-allowed bg-gray-100" : "cursor-pointer"
//         }`}
//         onClick={handleToggle}
//       >
//         <span className={`${!value ? "text-gray-400" : "text-black"}`}>
//           {value ? selectedOption?.label : placeholder}
//         </span>
//         <FaAngleDown className="text-themeBlue bg-red-100 rounded-full p-0.5 w-4 h-4" />
//       </div>

//       {isOpen && !disabled && (
//         <div className="absolute z-50 mt-1 w-full bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
//           {options.map(opt => {
//             const isSelected = value === opt.value;
//             return (
//               <div
//                 key={opt.value}
//                 className={`px-4 py-2 text-sm cursor-pointer flex items-center justify-between
//                   ${isSelected ? "bg-blue-100" : "hover:bg-gray-100"}
//                 `}
//                 onClick={() => handleSelect(opt.value)}
//               >
//                 <span className="capitalize">{opt.label}</span>
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomDropdown;

// version2 with multi select
// import { useState, useRef, useEffect } from "react";
// import { FaAngleDown } from "react-icons/fa";

// const CustomDropdown = ({
//   label,
//   value,
//   onChange,
//   options,
//   placeholder,
//   disabled,
//   isMulti = false, // default is false for single select
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const ref = useRef();

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (ref.current && !ref.current.contains(e.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const selectedOptions = isMulti
//     ? options?.filter((opt) => value?.includes(opt.value))
//     : options?.find((opt) => opt?.value === value);

//   const handleToggle = () => {
//     if (!disabled) {
//       setIsOpen(!isOpen);
//     }
//   };

//   const handleSelect = (val) => {
//     if (disabled) return;

//     if (isMulti) {
//       const alreadySelected = value?.includes(val);
//       const newValue = alreadySelected
//         ? value.filter((v) => v !== val)
//         : [...(value || []), val];
//       onChange(newValue);
//     } else {
//       onChange(val);
//       setIsOpen(false);
//     }
//   };

//   return (
//     <div
//       ref={ref}
//       className={`relative ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
//     >
//       {label && (
//         <label className="block text-lg font-semibold !text-themeBlue mb-3">
//           {label}
//         </label>
//       )}

//       <div
//         className={`w-full px-4 py-3 bg-white border border-themeCardBorder rounded-md shadow-sm flex justify-between items-center ${
//           disabled ? "cursor-not-allowed bg-gray-100" : "cursor-pointer"
//         }`}
//         onClick={handleToggle}
//       >
//         <span className={`${!value || (Array.isArray(value) && value.length === 0) ? "text-gray-400" : "text-black"}`}>
//           {isMulti
//             ? selectedOptions?.map((opt) => opt.label).join(", ") || placeholder
//             : value
//             ? selectedOptions?.label
//             : placeholder}
//         </span>
//         <FaAngleDown className="text-themeBlue bg-red-100 rounded-full p-0.5 w-4 h-4" />
//       </div>

//       {isOpen && !disabled && (
//         <div className="absolute z-50 mt-1 w-full bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
//           {options.map((opt) => {
//             const isSelected = isMulti
//               ? value?.includes(opt.value)
//               : value === opt.value;

//             return (
//               <div
//                 key={opt.value}
//                 className={`px-4 py-2 text-sm cursor-pointer flex items-center justify-between
//                   ${isSelected ? "bg-blue-100" : "hover:bg-gray-100"}
//                 `}
//                 onClick={() => handleSelect(opt.value)}
//               >
//                 <span className="capitalize">{opt.label}</span>
//                 {isSelected && <span className="text-blue-600 font-semibold">✓</span>}
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomDropdown;



// import { useState, useRef, useEffect } from "react";
// import { FaAngleDown } from "react-icons/fa";

// const CustomDropdown = ({
//   label,
//   value,
//   onChange,
//   options,
//   placeholder,
//   disabled,
//   isMulti = false,
//   allowCustomInput = false, // ✅ Only used for special dropdowns like "showDataOn"
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [customValue, setCustomValue] = useState("");
//   const [customError, setCustomError] = useState("");
//   const ref = useRef();

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (ref.current && !ref.current.contains(e.target)) {
//         setIsOpen(false);
//         setCustomError("");
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // ✅ This fixes the issue: ensure both option-based and custom values show
//   const selectedOptions = isMulti
//     ? (value || []).map((val) => {
//         const match = options?.find((opt) => opt.value === val);
//         return match || { label: `p${val}`, value: val };
//       })
//     : (() => {
//         const match = options?.find((opt) => opt.value === value);
//         return match || (value ? { label: `${value}%`, value } : null);
//       })();

//   const handleToggle = () => {
//     if (!disabled) {
//       setIsOpen((prev) => !prev);
//     }
//   };

//   const handleSelect = (val) => {
//     if (disabled) return;

//     if (isMulti) {
//       const alreadySelected = value?.includes(val);
//       const newValue = alreadySelected
//         ? value.filter((v) => v !== val)
//         : [...(value || []), val];
//       onChange(newValue);
//     } else {
//       onChange(val);
//       setIsOpen(false);
//     }
//   };

//   const handleAddCustomValue = () => {
//     const numeric = Number(customValue);

//     if (!numeric || numeric < 1 || numeric > 100) {
//       setCustomError("Enter a number between 1 and 100");
//       return;
//     }

//     const customVal = numeric.toString();
//     const alreadyExists = isMulti
//       ? value?.includes(customVal)
//       : value === customVal;

//     if (alreadyExists) {
//       setCustomError("Value already selected");
//       return;
//     }

//     setCustomError("");
//     setCustomValue("");

//     if (isMulti) {
//       onChange([...(value || []), customVal]);
//     } else {
//       onChange(customVal);
//       setIsOpen(false);
//     }
//   };

//   return (
//     <div
//       ref={ref}
//       className={`relative ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
//     >
//       {label && (
//         <label className="block text-lg font-semibold !text-themeBlue mb-3">
//           {label}
//         </label>
//       )}

//       <div
//         className={`w-full px-4 py-3 bg-white border border-themeCardBorder rounded-md shadow-sm flex justify-between items-center ${
//           disabled ? "cursor-not-allowed bg-gray-100" : "cursor-pointer"
//         }`}
//         onClick={handleToggle}
//       >
//         <span
//           className={`${
//             !value || (Array.isArray(value) && value.length === 0)
//               ? "text-gray-400"
//               : "text-black"
//           }`}
//         >
//           {isMulti
//             ? selectedOptions?.map((opt) => opt.label).join(", ") || placeholder
//             : value
//             ? selectedOptions?.label
//             : placeholder}
//         </span>
//         <FaAngleDown className="text-themeBlue bg-red-100 rounded-full p-0.5 w-4 h-4" />
//       </div>

//       {isOpen && !disabled && (
//         <div className="absolute z-50 mt-1 w-full bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
//           {options.map((opt) => {
//             const isSelected = isMulti
//               ? value?.includes(opt.value)
//               : value === opt.value;

//             return (
//               <div
//                 key={opt.value}
//                 className={`px-4 py-2 text-sm cursor-pointer flex items-center justify-between ${
//                   isSelected ? "bg-blue-100" : "hover:bg-gray-100"
//                 }`}
//                 onClick={() => handleSelect(opt.value)}
//               >
//                 <span className="capitalize">{opt.label}</span>
//                 {isSelected && (
//                   <span className="text-blue-600 font-semibold">✓</span>
//                 )}
//               </div>
//             );
//           })}

//           {/* ✅ Special custom input only if allowed */}
//           {allowCustomInput && (
//             <div className="px-4 py-3 border-t bg-gray-50">
//               <label className="block mb-1 text-sm font-medium text-gray-700">
//                 Enter Custom Percentile (1–100)
//               </label>
//               <div className="flex items-center gap-2">
//                 <input
//                   type="number"
//                   value={customValue}
//                   onChange={(e) => setCustomValue(e.target.value)}
//                   className="w-full px-2 py-1 border rounded"
//                   placeholder="e.g. 65"
//                   min={1}
//                   max={100}
//                 />
//                 <button
//                   className="bg-blue-500 text-white px-3 py-1 rounded"
//                   onClick={handleAddCustomValue}
//                 >
//                   Add
//                 </button>
//               </div>
//               {customError && (
//                 <p className="text-red-500 text-xs mt-1">{customError}</p>
//               )}
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomDropdown;



// import { useState, useRef, useEffect } from "react";
// import { FaAngleDown } from "react-icons/fa";
// import { MdClose } from "react-icons/md";

// const CustomDropdown = ({
//   label,
//   value,
//   onChange,
//   options,
//   placeholder,
//   disabled,
//   isMulti = false,
//   allowCustomInput = false,
//   customInputLimit = 2,
//   canDeleteCustomValues = false,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [customValue, setCustomValue] = useState("");
//   const [customError, setCustomError] = useState("");
//   const [customOptions, setCustomOptions] = useState([]);
//   const ref = useRef();

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (ref.current && !ref.current.contains(e.target)) {
//         setIsOpen(false);
//         setCustomError("");
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const allOptions = [...options, ...customOptions];

//   const selectedOptions = isMulti
//     ? (value || []).map((val) => {
//         const match = allOptions.find((opt) => opt.value === val);
//         return match || { label: `P${val}`, value: val };
//       })
//     : (() => {
//         const match = allOptions.find((opt) => opt.value === value);
//         return match || (value ? { label: `P${value}`, value } : null);
//       })();

//   const handleToggle = () => {
//     if (!disabled) setIsOpen((prev) => !prev);
//   };

//   const handleSelect = (val) => {
//     if (disabled) return;

//     if (isMulti) {
//       const current = value || [];
//       const isSelected = current.includes(val);
//       const newValues = isSelected
//         ? current.filter((v) => v !== val)
//         : [...current, val];
//       onChange(newValues);
//     } else {
//       onChange(val);
//       setIsOpen(false);
//     }
//   };

//   const handleAddCustomValue = () => {
//     const numeric = Number(customValue);

//     if (!numeric || numeric < 1 || numeric > 100) {
//       setCustomError("Enter a number between 1 and 100");
//       return;
//     }

//     const customVal = numeric.toString();
//     const alreadyExists = allOptions.some((opt) => opt.value === customVal);

//     if (alreadyExists) {
//       setCustomError("Value already selected");
//       return;
//     }

//     const newOption = { label: `P${customVal}`, value: customVal };
//     const updatedCustomOptions = [...customOptions, newOption];

//     setCustomOptions(updatedCustomOptions);
//     setCustomValue("");
//     setCustomError("");

//     if (isMulti) {
//       onChange([...(value || []), customVal]);
//     } else {
//       onChange(customVal);
//       setIsOpen(false);
//     }
//   };

//   const handleDeleteCustomOption = (val) => {
//     const updated = customOptions.filter((opt) => opt.value !== val);
//     setCustomOptions(updated);

//     // Remove from selected if applicable
//     if (isMulti) {
//       onChange((value || []).filter((v) => v !== val));
//     } else if (value === val) {
//       onChange("");
//     }
//   };

//   return (
//     <div
//       ref={ref}
//       className={`relative ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
//     >
//       {label && (
//         <label className="block text-lg font-semibold text-themeBlue mb-3" style={{color:"#00519D !important"}}>
//          <p className="text-themeBlue">

//          {label}
//          </p> 
//         </label>
//       )}

//       <div
//         className={`w-full px-4 py-3 bg-white border border-themeCardBorder rounded-md shadow-sm flex justify-between items-center ${
//           disabled ? "cursor-not-allowed bg-gray-100" : "cursor-pointer"
//         }`}
//         onClick={handleToggle}
//       >
//         <span
//           className={`capitalize ${
//             !value || (Array.isArray(value) && value.length === 0)
//               ? "text-gray-400"
//               : "text-black"
//           }`}
//         >
//           {isMulti
//             ? selectedOptions?.map((opt) => opt.label).join(", ") || placeholder
//             : value
//             ? selectedOptions?.label
//             : placeholder}
//         </span>
//         <FaAngleDown className="text-themeBlue bg-red-100 rounded-full p-0.5 w-4 h-4" />
//       </div>

//       {isOpen && !disabled && (
//         <div className="absolute z-50 mt-1 w-full bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
//           {allOptions.map((opt) => {
//             const isSelected = isMulti
//               ? (value || []).includes(opt.value)
//               : value === opt.value;

//             const isCustom = customOptions.some(
//               (custom) => custom.value === opt.value
//             );

//             return (
//               <div
//                 key={opt.value}
//                 className={`px-4 py-2 text-sm cursor-pointer flex items-center justify-between ${
//                   isSelected ? "bg-blue-100" : "hover:bg-gray-100"
//                 }`}
//                 onClick={() => handleSelect(opt.value)}
//               >
//                 <span className="capitalize">{opt.label}</span>
//                 <div className="flex items-center gap-2">
//                   {isSelected && (
//                     <span className="text-blue-600 font-semibold">✓</span>
//                   )}
//                   {canDeleteCustomValues && isCustom && (
//                     <MdClose
//                       className="text-red-500 hover:text-red-700 ml-2"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleDeleteCustomOption(opt.value);
//                       }}
//                     />
//                   )}
//                 </div>
//               </div>
//             );
//           })}

//           {allowCustomInput && (
//             <div className="px-4 py-3 border-t bg-gray-50">
//               <label className="block mb-1 text-sm font-medium text-themeBlue">
//                 Enter Custom Percentile (1–100)
//               </label>
//               <div className="flex items-center gap-2">
//                 <input
//                   type="number"
//                   value={customValue}
//                   onChange={(e) => setCustomValue(e.target.value)}
//                   className="w-full px-2 py-1 border rounded"
//                   placeholder="e.g. 65"
//                   min={1}
//                   max={100}
//                   disabled={customOptions.length >= customInputLimit}
//                 />
//                 <button
//                   className={`bg-blue-500 text-white px-3 py-1 rounded disabled:opacity-50 ${customOptions.length >= customInputLimit && "bg-gray-300 cursor-not-allowed"}`}
//                   onClick={handleAddCustomValue}
//                   disabled={customOptions.length >= customInputLimit}
//                 >
//                   Add
//                 </button>
//               </div>
//               {customError && (
//                 <p className="text-red-500 text-xs mt-1">{customError}</p>
//               )}
//               {customOptions.length >= customInputLimit && (
//                 <p className="text-xs text-gray-500 mt-1">
//                   Maximum of {customInputLimit} custom values reached.
//                 </p>
//               )}
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomDropdown;

import { useState, useRef, useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";
import { MdClose } from "react-icons/md";

const CustomDropdown = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  disabled,
  isMulti = false,
  allowCustomInput = false,
  customInputLimit = 2,
  canDeleteCustomValues = true, // ✅ ensure this is enabled
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [customValue, setCustomValue] = useState("");
  const [customError, setCustomError] = useState("");
  const [customOptions, setCustomOptions] = useState([]);
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
        setCustomError("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (customOptions.length < customInputLimit && customError) {
      setCustomError("");
    }
  }, [customOptions, customInputLimit, customError]);

  const allOptions = [...options, ...customOptions];

  const selectedOptions = isMulti
    ? (value || []).map((val) => {
        const match = allOptions.find((opt) => opt.value === val);
        return match || { label: `P${val}`, value: val };
      })
    : (() => {
        const match = allOptions.find((opt) => opt.value === value);
        return match || (value ? { label: `P${value}`, value } : null);
      })();

  const handleToggle = () => {
    if (!disabled) setIsOpen((prev) => !prev);
  };

  const handleSelect = (val) => {
    if (disabled) return;

    if (isMulti) {
      const current = value || [];
      const isSelected = current.includes(val);
      const newValues = isSelected
        ? current.filter((v) => v !== val)
        : [...current, val];
      onChange(newValues);
    } else {
      onChange(val);
      setIsOpen(false);
    }
  };

  const handleAddCustomValue = () => {
    const numeric = Number(customValue);

    if (!numeric || numeric < 1 || numeric > 100) {
      setCustomError("Enter a number between 1 and 100");
      return;
    }

    const customVal = numeric.toString();
    const alreadyExists = allOptions.some((opt) => opt.value === customVal);

    if (alreadyExists) {
      setCustomError("Value already selected");
      return;
    }

    const newOption = { label: `P${customVal}`, value: customVal };
    const updatedCustomOptions = [...customOptions, newOption];

    setCustomOptions(updatedCustomOptions);
    setCustomValue("");
    setCustomError("");

    if (isMulti) {
      onChange([...(value || []), customVal]);
    } else {
      onChange(customVal);
      setIsOpen(false);
    }
  };

  const handleDeleteCustomOption = (val) => {
    const updated = customOptions.filter((opt) => opt.value !== val);
    setCustomOptions(updated);

    // Remove from selected if applicable
    if (isMulti) {
      onChange((value || []).filter((v) => v !== val));
    } else if (value === val) {
      onChange("");
    }
  };

  return (
    <div
      ref={ref}
      className={`relative ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
    >
      {label && (
        <label className="block text-lg font-semibold text-themeBlue mb-3">
          <p className="text-themeBlue">{label}</p>
        </label>
      )}

      <div
        className={`w-full px-4 py-3 bg-white border border-themeCardBorder rounded-md shadow-sm flex justify-between items-center ${
          disabled ? "cursor-not-allowed bg-gray-100" : "cursor-pointer"
        }`}
        onClick={handleToggle}
      >
        <span
          className={`capitalize ${
            !value || (Array.isArray(value) && value.length === 0)
              ? "text-gray-400"
              : "text-black"
          }`}
        >
          {isMulti
            ? selectedOptions?.map((opt) => opt.label).join(", ") || placeholder
            : value
            ? selectedOptions?.label
            : placeholder}
        </span>
        <FaAngleDown className="text-themeBlue bg-red-100 rounded-full p-0.5 w-4 h-4" />
      </div>

      {isOpen && !disabled && (
        <div className="absolute z-50 mt-1 w-full bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
          {allOptions.map((opt) => {
            const isSelected = isMulti
              ? (value || []).includes(opt.value)
              : value === opt.value;

            const isCustom = customOptions.some(
              (custom) => custom.value === opt.value
            );

            return (
              <div
                key={opt.value}
                className={`px-4 py-2 text-sm cursor-pointer flex items-center justify-between ${
                  isSelected ? "bg-blue-100" : "hover:bg-gray-100"
                }`}
                onClick={() => handleSelect(opt.value)}
              >
                <span className="capitalize">{opt.label}</span>
                <div className="flex items-center gap-2">
                  {isSelected && (
                    <span className="text-blue-600 font-semibold">✓</span>
                  )}
                  {canDeleteCustomValues && isCustom && (
                    <MdClose
                      className="text-red-500 hover:text-red-700 ml-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteCustomOption(opt.value);
                      }}
                    />
                  )}
                </div>
              </div>
            );
          })}

          {allowCustomInput && (
            <div className="px-4 py-3 border-t bg-gray-50">
              <label className="block mb-1 text-sm font-medium text-themeBlue">
                Enter Custom Percentile (1–100)
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  value={customValue}
                  onChange={(e) => setCustomValue(e.target.value)}
                  className="w-full px-2 py-1 border rounded"
                  placeholder="e.g. 65"
                  min={1}
                  max={100}
                  disabled={customOptions.length >= customInputLimit}
                />
                <button
                  className={`text-white px-3 py-1 rounded ${
                    customOptions.length >= customInputLimit
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-blue-500"
                  }`}
                  onClick={handleAddCustomValue}
                  disabled={customOptions.length >= customInputLimit}
                >
                  Add
                </button>
              </div>
              {customError && (
                <p className="text-red-500 text-xs mt-1">{customError}</p>
              )}
              {customOptions.length >= customInputLimit && (
                <p className="text-xs text-gray-500 mt-1">
                  Maximum of {customInputLimit} custom values reached.
                </p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;

